<template>
    <div v-if="total > elements" class="col col-12 ctn-more">
        <button class="btn-search-more" v-if="dictionary" v-on:click.prevent="emitLoadMore()"> {{dictionary["SUCHE_Mehr_anzeigen"]}} </button>
    </div>
    
</template>

<script setup lang="ts">
import { emitterInstance } from '@/classes/emitter';

    const props = defineProps({
        total: {
            type: Number,
            required: true,
        },
        elements: {
            type: Number,
            required: true,
        },
        element: {
            type: Object,
            required: true,
        },
        emit:{
            type: String,
            required: true,
        }
    });
    const dictionary = {
        'SUCHE_Mehr_anzeigen': 'Mehr anzeigen',
    }
    const emitLoadMore= ()=>{
        emitterInstance.emit(props.emit, props.element);
    }
    
</script>